import { EventName } from '@lit/react';
import { BlocksTab } from 'blocks-nextjs/blocks-web-components/components/tab/tab';
import { BlocksTabSelectEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatTab = createComponent({
  react: React,
  tagName: 'cat-tab',
  elementClass: BlocksTab,
  events: {
    onBlTabSelect: 'bl-tab-select' as EventName<BlocksTabSelectEvent>
  }
});
